import React, { useEffect } from "react";
import { getFeatureFlagStatuses } from "../store/actions/miscActionCreators";
import { notification } from "antd";
import { FeatureFlagStatusesDto } from "../store/actions/dtos/FeatureFlagStatusesDto";

//default all feature flags to false
const defaultValues: FeatureFlagStatusesDto = {
  advancedFlow: false,
  newOrderButton: false,
  newRgaButton: false,
  newHardwareOrderButton: false,
  cloneOrderButton: false,
  alterationCheckbox: false,
  replacementLookup: false,
};

export default function useGetFeatureFlagStatuses() {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [featureFlags, setFeatureFlags] =
    React.useState<FeatureFlagStatusesDto>(defaultValues);

  useEffect(() => {
    setIsLoading(true);
    getFeatureFlagStatuses()
      .then(([response]) => {
        if (response) {
          setFeatureFlags(response.data);
        }
        setIsLoading(false);
      })
      .catch((e: any) => {
        notification.open({
          message: e,
        });
        setIsLoading(false);
      });
  }, []);

  return { isLoading, ...featureFlags };
}
